import { createAsyncThunk } from '@reduxjs/toolkit';
import { getSidebarMenusService } from './menuService';

export const getAuthorizedMenus = createAsyncThunk(
  'menu/getSidebar',
  async (_, { rejectWithValue }) => {
    try {
      const response = await getSidebarMenusService();
      if (response.status) {
        return response.data;
      }
      return rejectWithValue(response.message || 'Failed to fetch menus');
    } catch (error) {
      return rejectWithValue(error?.message || 'Failed to fetch menus');
    }
  }
);
